export default __webpack_public_path__ + "static/media/fNeutral18.33755e9d.png";